function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "as", "className", "dataSpacer", "isDark", "isFullWidth", "hasBorder", "noBackground", "noShadow", "noSpacing", "radius", "smallSpacing"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import classNamesMaker from "classnames";
import paperStyle from "./paper.module.css";
export var PAPER_RADIUS = {
  DEFAULT: "radius",
  ROUNDED: "radiusRounded"
};

/**
 * The type of all the props of the Paper component
 */

/**
 * The 2 types of the Paper component
 */

// eslint-disable-next-line react/function-component-definition
export function Paper(_ref) {
  var children = _ref.children,
    as = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$dataSpacer = _ref.dataSpacer,
    dataSpacer = _ref$dataSpacer === void 0 ? undefined : _ref$dataSpacer,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    _ref$noShadow = _ref.noShadow,
    noShadow = _ref$noShadow === void 0 ? false : _ref$noShadow,
    _ref$noSpacing = _ref.noSpacing,
    noSpacing = _ref$noSpacing === void 0 ? false : _ref$noSpacing,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? undefined : _ref$radius,
    _ref$smallSpacing = _ref.smallSpacing,
    smallSpacing = _ref$smallSpacing === void 0 ? false : _ref$smallSpacing,
    props = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var CustomTag = as || "div";
  var customClassNames = classNamesMaker(paperStyle["jds-Paper"], _defineProperty({}, paperStyle["jds-Paper--".concat(radius)], !!radius), _defineProperty({}, paperStyle["jds-Paper--isFullWidth"], isFullWidth), _defineProperty({}, paperStyle["jds-Paper--hasBorder"], hasBorder), _defineProperty({}, paperStyle["jds-Paper--noBackground"], noBackground), _defineProperty({}, paperStyle["jds-Paper--noShadow"], noShadow), _defineProperty({}, paperStyle["jds-Paper--noSpacing"], noSpacing), _defineProperty({}, paperStyle["jds-Paper--smallSpacing"], smallSpacing), _defineProperty({}, paperStyle["jds-Paper--isDark"], isDark), className);
  var customAttributes = _objectSpread({}, dataSpacer && dataSpacer.length > 0 ? {
    "data-spacer": dataSpacer
  } : {});
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(CustomTag, _extends({}, props, {
      className: customClassNames
    }, customAttributes), children)
  );
}